<template>
  <div class="le-pagination" v-if="paginate">
    <div class="text">Showing {{paginate.per_page}} out of a total of {{paginate.total}} records.</div>
    <div class="buttons">
        <div class="column is-1">
          <button class="button" v-if="paginate.prev_page_url" @click="page(paginate.current_page - 1)">&lt;</button>
        </div>
        <div class="column is-10 has-text-centered">

          <button class="button" @click="page(1)" v-if="paginate.current_page >= 5">1</button>
          <button class="button" @click="page(2)" v-if="paginate.current_page >= 6">2</button>
          <span class="divider" v-if="paginate.current_page >= 5">...</span>
          <button class="button" @click="page(paginate.current_page -4 +i)" :class="{'is-primary' : paginate.current_page === paginate.current_page -4 + i}" v-for="i in 7" v-bind:key="i" v-if="paginate.current_page -4 + i <= paginate.last_page && paginate.current_page -4 +i > 0">{{paginate.current_page -4 + i}}</button>
          <span class="divider" v-if="paginate.current_page < paginate.last_page -4">...</span>
          <button class="button" @click="page(paginate.last_page -1)" v-if="paginate.current_page < paginate.last_page -4">{{paginate.last_page -1}}</button>
          <button class="button" @click="page(paginate.last_page)" v-if="paginate.current_page < paginate.last_page -3">{{paginate.last_page}}</button>

        </div>
        <div class="column is-1">
          <button class="button" v-if="paginate.next_page_url" @click="page(paginate.current_page + 1)">&gt;</button>
        </div>
    </div>

  </div>
</template>
<style lang="scss">
  .le-pagination{
    padding:15px 10px;
    .buttons{
      width: 100%;
    }
  }

</style>
<script>
export default {
  name: 'Pagination',
  data () {
    return {

    }
  },
  watch: {
    paginate: function () {
      if (this.paginate) {
        if (this.paginate.current_page > this.paginate.last_page) {
          this.$router.push(
            {
              name: this.$router.currentRoute.name,
              query: { page: this.paginate.last_page }
            }
          )
        }
      }
    }
  },
  computed: {
    paginate: function () {
      return (this.$store.state.data ? this.$store.state.data['@Links'] : {})
    }
  },
  methods: {
    page: function (page) {
      this.$router.push(
        {
          name: this.$router.currentRoute.name,
          query: { page }
        }
      )
    }
  }
}
</script>
